// Cliente del plugin puente del editor (public/office/bridge).
// El plugin corre dentro del editor y al iniciar le entrega a esta página un MessageChannel.

export function createBridge() {
  let port = null;
  let seq = 0;
  const pending = new Map();
  const waiters = [];

  const onMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.data?.type !== 'office-bridge-ready' || !event.ports?.[0]) return;
    port?.close?.();
    port = event.ports[0];
    port.onmessage = (ev) => {
      const entry = pending.get(ev.data?.id);
      if (!entry) return;
      pending.delete(ev.data.id);
      clearTimeout(entry.timer);
      if (ev.data.ok) entry.resolve(ev.data.result);
      else entry.reject(new Error(ev.data.result || 'El editor no pudo completar la acción'));
    };
    waiters.splice(0).forEach((resolve) => resolve());
  };
  window.addEventListener('message', onMessage);

  const ready = (timeout = 20000) => {
    if (port) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('El editor todavía está cargando')), timeout);
      waiters.push(() => {
        clearTimeout(timer);
        resolve();
      });
    });
  };

  const call = async (cmd, args = {}, timeout = 30000) => {
    await ready();
    return new Promise((resolve, reject) => {
      seq += 1;
      const id = seq;
      const timer = setTimeout(() => {
        pending.delete(id);
        reject(new Error('El editor no respondió a tiempo'));
      }, timeout);
      pending.set(id, { resolve, reject, timer });
      port.postMessage({ id, cmd, args });
    });
  };

  const dispose = () => {
    window.removeEventListener('message', onMessage);
    pending.forEach((entry) => clearTimeout(entry.timer));
    pending.clear();
    port?.close?.();
    port = null;
  };

  return { call, ready, dispose };
}
